export const CONNETION_FAILED = "Connection failed";

export const CONNECTIVITY_ERROR =
  "We're having trouble connecting to SharePoint. Please try again. If the issue continues, please contact the system administrator.";

export const NO_SITE_ERROR =
  "This site is no longer available.\n\n It may have been deleted or you no longer have permission to access it. It will no longer appear in your pinned sites.";

export const LIMIT = 50;

export const ACCESS_BATCH_SIZE = 5;

export const SKIP_REDIRECT = { skipAuthRedirect: true };

export const TEST_JOB = "testSharepointSettings";

export const TEST_POLL_INTERVAL = 1000;

export const TEST_POPUP_BLOCKED =
  "Allow pop-ups for this site to test the SharePoint connection.";

export const TEST_SIGN_IN_CLOSED =
  "The Microsoft sign-in window was closed before the connection was tested.";

export const TEST_TIMED_OUT =
  "The SharePoint connection test timed out. Try again.";

export const SP_AUTH_REDIRECT_KEY = "sp_auth_redirect";

export const VISI_PENDING_STATE_KEY = "visi_pending_state";

export const FIVE_MINUTES = 5 * 60 * 1000;

export const SP_AUTH_POPUP_ERROR_TEXT =
  "Couldn't open the sign-in window. Please allow pop-ups for this site and try again.";

export const SP_AUTH_FAILED_ERROR_TEXT =
  "SharePoint sign-in failed. Please try connecting again.";

export const OFFICE_DIALOG_ERROR_USER_CLOSED = 12006;
